import { Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ThanksQuote = () => {
  const navigate = useNavigate();
  return (
    <Container sx={{ width: '100%', marginTop: 4 }}>
      <Stack spacing={4}>
        <Typography variant="h2">
          Gracias por finalizar tu cotización
        </Typography>
        <Button onClick={() => navigate('/')}>Regresar a Inicio</Button>
      </Stack>
    </Container>
  );
};

export default ThanksQuote;
